import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { useState, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
var Wrapper = styled.div.withConfig({
  displayName: "CollapsibleGroup__Wrapper",
  componentId: "sc-18a1lqs-0"
})([""]);
export var CollapsibleGroupContext = /*#__PURE__*/React.createContext();
export function useCollapsibleGroupState() {
  return useContext(CollapsibleGroupContext);
}
/**
 * Use this to prevent any nested Collapsibles from thinking they're part of any
 * parent CollapsibleGroup when nested.
 */

export function UnsetGroup(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(CollapsibleGroupContext.Provider, null, children);
}
UnsetGroup.propTypes = {
  children: PropTypes.node
};
export default function CollapsibleGroup(_ref2) {
  var _ref2$allowMultipleOp = _ref2.allowMultipleOpen,
      allowMultipleOpen = _ref2$allowMultipleOp === void 0 ? false : _ref2$allowMultipleOp,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ["allowMultipleOpen", "children"]);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      openId = _useState2[0],
      setOpenId = _useState2[1];

  var context = useMemo(() => ({
    allowMultipleOpen,
    openId,
    setOpenId
  }), [allowMultipleOpen, openId]);
  return /*#__PURE__*/React.createElement(Wrapper, rest, /*#__PURE__*/React.createElement(CollapsibleGroupContext.Provider, {
    value: context
  }, children));
}
CollapsibleGroup.propTypes = {
  /**
   * Allows multiple `Collapsible` components to be open. If false, then only one can be open at a time.
   */
  allowMultipleOpen: PropTypes.bool,

  /**
   * Content of the CollapsibleGroup. Usually `Collapsible` components.
   */
  children: PropTypes.node
};
CollapsibleGroup.UnsetGroup = UnsetGroup;
CollapsibleGroup.useState = useCollapsibleGroupState;